import { BASE_URL_API } from "../../../constants";
import fetcher, { _api_download_file } from "../../../utils/fetcher";

const get = (path, searchParams) => {
    const params = searchParams ? `?${searchParams}` : "";
    return fetcher(`${BASE_URL_API}/hr/pilotage/${path}${params}`, {
        method: "GET",
        credentials: "include",
    });
};

/** GET /api/hr/pilotage/effectif?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_effectif = (searchParams) =>
    get("effectif", searchParams);

/** GET /api/hr/pilotage/diversite?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_diversite = (searchParams) =>
    get("diversite", searchParams);

/** GET /api/hr/pilotage/retention?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_retention = (searchParams) =>
    get("retention", searchParams);

/** GET /api/hr/pilotage/mouvements?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_mouvements = (searchParams) =>
    get("mouvements", searchParams);

/** GET /api/hr/pilotage/absenteisme?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_absenteisme = (searchParams) =>
    get("absenteisme", searchParams);

/** GET /api/hr/pilotage/temps-travail?agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_temps_travail = (searchParams) =>
    get("temps-travail", searchParams);

/** GET /api/hr/pilotage/frais?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_frais = (searchParams) =>
    get("frais", searchParams);

/** GET /api/hr/pilotage/taches?period=ytd&agency_ids=1&manager_ids=1 */
export const _api_get_pilotage_taches = (searchParams) =>
    get("taches", searchParams);

/** GET /api/hr/pilotage/indicators : préférences d'affichage de l'utilisateur connecté */
export const _api_get_pilotage_indicators = () => get("indicators");

/** POST /api/hr/pilotage/indicators { type: "indicator" | "group", code, visible } */
export const _api_post_pilotage_indicators = (body) =>
    fetcher(`${BASE_URL_API}/hr/pilotage/indicators`, {
        method: "POST",
        body: JSON.stringify(body),
        credentials: "include",
    });

/** GET /api/hr/pilotage/export/synthese?start_date=…&end_date=…&sections=…&compare_by=…&export_format=xlsx */
export const _api_export_pilotage_synthese = ({
    searchParams,
    exportFormat,
    cbOnEndDownload,
}) =>
    _api_download_file({
        url: `${BASE_URL_API}/hr/pilotage/export/synthese?${searchParams}`,
        defaultFilename: `pilotage_rh_synthese.${exportFormat}`,
        cbOnEndDownload,
    });
